module.exports = __webpack_public_path__ + "img/drip.b17bc930.jpg";